module.exports = __webpack_public_path__ + "img/icon_4.cf42ab07.png";